import React, { useState, useEffect } from 'react';
import { Breadcrumbs, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { ROUTE_KEYS } from 'utils/constants';
import PageHeaderText from 'components/base/page-header-text';
import { apiService } from 'services/base.service';

interface Quarterly {
  id: string;
  created_at: string;
  updated_at: string;
  title: string;
  reward_duration_in_weeks: number;
  weekly_reward_price: number;
  minimum_spend_per_week: number;
}
const CashbackControl = () => {
  const breadCrumbs = [
    { name: 'Maintenance', path: ROUTE_KEYS.MAINTENANCE },
    { name: 'Cashback Control', path: '' }
  ];

  const [quarterData, setQuarterData] = useState<Quarterly[]>([]);

  const [loading, setLoading] = useState(false);

  const fetchQuarter = async () => {
    try {
      setLoading(true);
      const response = await apiService.get(`loyalty-cash-back-level`, {
        isInternal: true
      });
      setQuarterData(response.data);
    } catch (err) {
      toast(<ToastMessage type='error' message='Error fetching data' />);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuarter();
  }, []);

  const handleWeeklyRewardPriceChange = (index: number, value: string) => {
    const updatedQuarterData = [...quarterData];
    updatedQuarterData[index].weekly_reward_price = parseFloat(value);
    setQuarterData(updatedQuarterData);
  };

  //   const handleMinimumSpendChange = (index: number, value: string) => {
  //     const updatedQuarterData = [...quarterData];
  //     updatedQuarterData[index].minimum_spend_per_week = parseFloat(value);
  //     setQuarterData(updatedQuarterData);
  //   };

  const updateCashbackControl = async () => {
    setLoading(true);
    try {
      const updateData = quarterData.map((quarter) => ({
        id: quarter.id,
        title: quarter.title,
        reward_duration_in_weeks: quarter.reward_duration_in_weeks,
        weekly_reward_price: quarter.weekly_reward_price,
        minimum_spend_per_week: quarter.minimum_spend_per_week
      }));
      const payload = { cashBackLevels: updateData };
      await apiService.put(`internal/loyalty-cash-back-level/bulk`, {
        data: payload,
        isInternal: true
      });
      toast(<ToastMessage type='success' message='Changes have been saved' />);
    } catch (err) {
      toast(<ToastMessage type='error' message='Error updating data' />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className='md:ml-3 '>
        <Breadcrumbs breadcrumbs={breadCrumbs} />
        <div className='max-w-[800px] h-auto pr-6 pl-1 pb-6 pt-3 items-center'>
          <PageHeaderText
            title='Cashback Controls'
            description='Set cashback rewarded to a user after being consistent for a week in a quarter.'
          />

          {quarterData.map((quarter, index) => (
            <div key={index} className='mt-8 flex flex-col items-center md:flex-row mb-8'>
              <span className='text-sm text-[#1a1a1a] whitespace-nowrap'>{`Quarter ${
                index + 1
              }`}</span>
              <div className='mb-4 md:mr-8 ml-6 md:mb-0'>
                <div className='flex items-center border h-[40px] w-[300px] md:w-[auto] border-gray-2 rounded-md p-1 mt-2'>
                  <input
                    type='text'
                    value={quarter.weekly_reward_price.toString()}
                    onChange={(e) => handleWeeklyRewardPriceChange(index, e.target.value)}
                    className='border-white p-1 text-sm focus:outline-none w-full md:w-[200px]'
                    placeholder='Amount to be spent'
                  />
                  <span className='border rounded-md border-[#F2F2F3] p-1 bg-[#F2F2F3] ml-2 md:ml-[60px] text-xs text-gray-6'>
                    NGN
                  </span>
                </div>
              </div>

              {/* <div className='flex flex-col items-center md:w-[600px]'>
                <div className='flex items-center border h-[40px] md:w-[300px] border-gray-2 rounded-md p-1 mt-2'>
                  <input
                    type='text'
                    value={quarter.minimum_spend_per_week.toString()}
                    onChange={(e) => handleMinimumSpendChange(index, e.target.value)}
                    className='border-white p-1 text-sm focus:outline-none w-full md:w-[200px]'
                    placeholder='Minimum spend'
                  />
                  <span className='border rounded-md border-[#F2F2F3] p-1 bg-[#F2F2F3] ml-2 md:ml-[60px] text-xs text-gray-6'>
                    NGN
                  </span>
                </div>
              </div> */}
            </div>
          ))}

          <Button
            onClick={updateCashbackControl}
            className='w-[170px] h-[30px] mt-12 mr-6 ml-auto'
            variant='block'
            color='primary'
            loading={loading}>
            Update
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CashbackControl;
